import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper'
import { createNamespacedHelpers } from 'vuex'
import { CardSectionService } from '~/service/api'
import { CustomCardSection } from '~/models/CardSection'

export interface State {
  detail: CustomCardSection,
  draft: CustomCardSection
}

export interface Actions {
  create: void
  update: void
  delete: string
}

export interface Mutations {
  clear: void,
  clearDraft: void,
  set: CustomCardSection,
  setDraft: CustomCardSection,
  updateDraftField: { field: string, value: any }
}

export interface Getters {}

export function state() {
  const state: State = {
    detail: new CustomCardSection(),
    draft: new CustomCardSection()
  }
  return state
}

export const getters: DefineGetters<Getters, State> = {}

export const actions: DefineActions<Actions, State, Mutations, Getters> = {
  async create({ state, commit }) {
    await CardSectionService.cardSectionCreate({
      data: state.draft
    }).then((response) => {
      commit('set', response)
    })
  },
  async update({ state, commit }) {
    await CardSectionService.cardSectionUpdate({
      id: state.draft.id ?? '',
      data: state.draft
    }).then((response) => {
      commit('set', response)
    })
  },
  async delete({}, id) {
    await CardSectionService.cardSectionDelete({
      id
    })
  }
}

export const mutations: DefineMutations<Mutations, State> = {
  clear(state) {
    state.detail = new CustomCardSection()
  },
  clearDraft(state) {
    state.draft = new CustomCardSection()
  },
  set(state, item) {
    state.detail = item
  },
  setDraft(state, item) {
    state.draft = new CustomCardSection(item)
  },
  updateDraftField(state, { field, value }) {
    (state.draft as any)[field] = value
  }
}

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} = createNamespacedHelpers<State, Getters, Mutations, Actions>('sections')

export const sections = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
